import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" }),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.616 12.32l9.317 11.18H.5V.842L20.04 11.5H10.931l.684.82z",
      fill: "#C51918",
      stroke: "#4857A1"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "NP_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 22,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11.616 12.32l9.317 11.18H.5V.842L20.04 11.5H10.931l.684.82z",
        fill: "#fff",
        stroke: "#fff"
      }
    )
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#NP_svg__a)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.83 20.01L4.604 21.6l-.056-2.006-1.926.566 1.134-1.657-1.891-.673 1.89-.674-1.133-1.657 1.926.566.056-2.006 1.226 1.59 1.225-1.59.056 2.007 1.926-.567-1.134 1.657 1.891.674-1.89.674 1.133 1.656-1.926-.566-.056 2.006-1.225-1.59zM5.8 8.139l-.64.83-.029-1.048-1.005.296.592-.865L3.73 7l.988-.352-.592-.865 1.005.296.03-1.048.64.83.64-.83.03 1.048 1.005-.296-.592.865L7.87 7l-.987.352.592.865-1.006-.296-.03 1.048-.64-.83z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.666 7.894c2.226.009 3.413-1.254 3.413-1.254.235 1.441-1.578 2.4-3.392 2.4-1.813 0-2.911-1.307-3.587-2.4 0 0 1.34 1.245 3.566 1.254z",
      fill: "#F9FAFA"
    }
  ))
), a = t;
export {
  a as default
};
